module.exports = __webpack_public_path__ + "h5/img/f4.244c1c41.jpg";